import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PayoutForm from "@/components/PayoutForm";

const NAVY = "#132a63";

export default function PagosSocio() {
  return (
    <div style={{ minHeight: "100vh", background: NAVY, padding: "24px 16px", fontFamily: "'Poppins',system-ui,sans-serif" }}>
      <Helmet><title>Datos de pago — Mi Ángel Asís</title></Helmet>
      <div style={{ maxWidth: 760, margin: "0 auto" }}>
        <Link to="/socios" style={{ color: "#cbd5e1", fontSize: 14, textDecoration: "none" }} data-testid="pagos-back">← Volver al panel</Link>
        <div style={{ color: "white", fontSize: 24, fontWeight: 800, margin: "10px 0 4px" }}>Datos para recibir tus comisiones</div>
        <p style={{ color: "#cbd5e1", fontSize: 14, marginBottom: 18 }}>Para depositarte tus comisiones necesitamos tu cuenta y tus datos fiscales.</p>
        <div style={{ background: "white", borderRadius: 18, padding: "24px 22px" }}>
          <PayoutForm
            getUrl="/afiliados/payout-profile"
            putUrl="/afiliados/payout-profile"
            docUrl="/afiliados/payout-profile/document"
          />
        </div>
      </div>
    </div>
  );
}
